import { useMutation } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { useAuth0 } from '../auth/AuthProvider';
import { graphqlRequest } from '../utils/graphqlClient';
import {
  profileQueryKeys,
  useProfileMutationFeedback,
} from './useProfileMutationFeedback';

const updateUserMutation = graphql(/* GraphQL */ `
  mutation updateUser($user: UserUpdateInput!) {
    updateUser(input: $user)
  }
`);

export type UserUpdateInput = {
  userId: number;
  auth0Id?: string | null;
  fullName: string;
  email: string;
  gender?: string | null;
  phone?: string | null;
  dateOfBirth?: string | null;
  specialRequest?: string | null;
};

const useUpdateUser = () => {
  const { getAccessTokenSilently, isAuthenticated, user } = useAuth0();
  const userId = user?.sub ?? '';
  const feedback = useProfileMutationFeedback({
    successMessage: 'Profile updated',
    queryKeys: [profileQueryKeys.user(userId)],
  });

  return useMutation({
    mutationFn: async (input: UserUpdateInput) => {
      if (!isAuthenticated) {
        throw new Error('User must be authenticated to update user');
      }
      return graphqlRequest(
        updateUserMutation,
        { user: input },
        getAccessTokenSilently,
      );
    },
    ...feedback,
  });
};

export default useUpdateUser;
